import { sessionURL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { SessionAPIResponse } from '../../../NonReact/Types/Types'
import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export const getSession = (): Promise<JSONResponse<SessionAPIResponse>> =>
    requestJSON<SessionAPIResponse>(sessionURL, {
        method: RESTMethods.POST
    })
